module.exports = __webpack_public_path__ + "static/pic08.c55eca59.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic08.jpg
// module id = 133
// module chunks = 65868693374900 89684000601253